export default "__VITE_ASSET__C1YH42ip__"